<template>
  <div>
    <form @submit.prevent="confirmRecharge">
      <div class="md-layout">
        <div class="md-layout-item">
          <md-field>
            <label>Số tiền trừ</label>
            <md-input
              v-model="amount"
              :oninput="(amount = formatNumber(amount))"
              pattern="^[0-9].*$"
              title="Trường chỉ cho phép nhập số"
            ></md-input>
          </md-field>
        </div>
        <div class="md-layout-item">
          <md-field>
            <label>Ghi chú</label>
            <md-input v-model="note" md-autogrow></md-input>
          </md-field>
        </div>
      </div>
      <div class="formActions">
        <md-button
          class="md-success md-size-10"
          type="submit"
          :disabled="flagLoading"
        >
          <i class="fas fa-check"></i>
          Hoàn tất
        </md-button>
      </div>
    </form>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import EventBus from "../../EventBus";
import { mapGetters } from "vuex";
export default {
  props: ["user", "functions"],
  data() {
    return {
      amount: 0,
      isDeposit: false,
      note: "",
    };
  },
  computed: {
    ...mapGetters(["flagLoading"]),
  },
  methods: {
    recharge() {
      var amount = parseFloat(this.amount.replace(/\./g, ""));
      if (amount > parseFloat(this.user.data.deposit)) {
        this.$messageError("Số tiền trừ quá lớn");
      } else {
        let bits = localStorage.getItem("bits");
        this.$store.dispatch("FLAG_LOADING", true);
        var recharge = this.functions.httpsCallable(
          process.env.VUE_APP_CHANGE_DEPOSIT_FUNC + bits
        );
        recharge({
          amount: parseFloat(this.amount.replace(/\./g, "")),
          isDeposit: this.isDeposit,
          employeeCode: this.user.data.employeeCode,
          note: this.note,
        }).then((result) => {
          if (result.data.success === true) {
            this.$messageSuccess("Trừ tiền thành công");
            this.$store.dispatch("FLAG_LOADING", false);
            this.$emit("deduct", parseFloat(this.amount.replace(/\./g, "")));
            EventBus.$emit("reloadHistory");
          } else {
            this.$messageError("Trừ tiền không thành công");
            this.$store.dispatch("FLAG_LOADING", false);
          }
        });
        this.amount = 0;
        this.note = null;
      }
    },
    confirmRecharge() {
      Swal.fire({
        title: "Xác nhận",
        text: `Trừ tiền tài khoản: ${this.user.data.name}`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "OK",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.recharge();
        }
      });
    },
  },
};
</script>
<style lang="css" scoped>
</style>
